import { Component, Input, OnInit } from '@angular/core';
import { PrCardCenter } from '../pr-card-center/pr-card-center.component';
import { PrCardType } from '../pr-card/pr-card.component';

@Component({
    selector: 'pr-cards-center',
    templateUrl: './pr-cards-center.component.html',
    styleUrls: ['./pr-cards-center.component.scss'],
    standalone: false
})
export class PrCardsCenterComponent implements OnInit {
  @Input() cardsCenter: PrCardCenter[];
  @Input() vertical: boolean = false;
  @Input() fill: boolean = false;
  PrCardType = PrCardType;

  constructor() {}

  ngOnInit() {}

  get clazz() {
    if (this.vertical) return 'vertical';
    else if (this.cardsCenter && this.cardsCenter.length >= 4)
      return 'grid mbxl grid-col-4 grid-col-md-2 grid-col-sm-1';
    else if (this.cardsCenter && this.cardsCenter.length >= 3)
      return 'grid mbxl grid-col-3 grid-col-sm-2 grid-col-xs-1';
    else return 'grid mbxl grid-col-2 grid-col-xs-1';
  }
}
